import { render } from "./Details.vue?vue&type=template&id=5c855f70&scoped=true&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import "./Details.vue?vue&type=style&index=0&id=5c855f70&lang=scss&scoped=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c855f70"],['__file',"resources/js/Pages/Orchard/Plots/Fertilizations/Details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c855f70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c855f70', __exports__)) {
    console.log('reload')
    api.reload('5c855f70', __exports__)
  }
  
  module.hot.accept("./Details.vue?vue&type=template&id=5c855f70&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5c855f70', render)
  })

}


export default __exports__